<template>
  <div class="set-page">
    <div class="layout-title">
      <i class="iconfont icon-shouye"></i>
      <span class="route-name">{{ routeInfo.title }}</span>
    </div>
    <div class="set-con">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      routeInfo: {
        title: ''
      }
    }
  },
  watch: {
    $route() {
      this.getRouteInfo()
    }
  },
  mounted() {
    this.getRouteInfo()
  },
  methods: {
    getRouteInfo () {
      this.routeInfo.title = this.$route.meta.title
    }
  }
}
</script>

<style scoped lang="less">
  .set-page{
    height: calc(100vh - 125px);
    margin: 10px 20px;
    background-image: url("../../assets/dp/bottom-left.png");
    background-size: 100% 100%;
    padding: 0 30px;
    .layout-title{
      height: 75px;
      border-bottom: 1px solid #00B2FF;
      font-size: 26px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 85px;
      i{
        font-size: 23px;
        margin-right: 10px;
        color: #00B2FF;
      }
      .route-name{
        text-shadow: 3px 3px 5px #00B2FF;
      }
    }
    .set-con{
      width: 100%;
      height: calc(100% - 75px);
    }
  }
</style>
